module.exports = __webpack_public_path__ + "static/media/icon-grid.59e5be50.svg";